import type { TranslateDescriptionRequest, TranslateDescriptionResponse } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const translateApi = {
  async description(
    businessId: string,
    request: TranslateDescriptionRequest,
  ): Promise<TranslateDescriptionResponse> {
    const res = await api.api.businesses[':businessId']['ai-studio']['translate-description'].$post(
      { param: { businessId }, json: request },
    )
    return unwrap<TranslateDescriptionResponse>(res)
  },
}
